var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron-left-16px"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("rect",{"width":"16","height":"16","fill":"none","key":0}),React.createElement("polygon",{"points":"10.828 0.929 5.172 6.586 3.757 8 5.172 9.414 10.828 15.071 12.243 13.657 6.586 8 12.243 2.343 10.828 0.929","key":1})]))]);
}

ChevronLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
